import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MailAccountsRoutingModule } from './mail-accounts-routing.module';
import { MailAccountsListComponent } from './mail-accounts-list/mail-accounts-list.component';
import { MailAccountsDetailComponent } from './mail-accounts-detail/mail-accounts-detail.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TimelineModule } from 'primeng/timeline';
import { CalendarModule } from 'src/app/calendar/calendar.module';
import { CoreModule } from 'src/app/core/core.module';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [MailAccountsListComponent, MailAccountsDetailComponent],
  imports: [
    CommonModule,
    MailAccountsRoutingModule,
    ButtonModule,
    TableModule,
    ConfirmDialogModule,
    DialogModule,
    FormsModule,
    CheckboxModule,
    CoreModule,
    CardModule,
    FontAwesomeModule,
    InputTextareaModule,
    DropdownModule,
    CalendarModule,
    SplitButtonModule,
    TimelineModule,
    InputTextModule,
    TranslateModule
  ]
})
export class MailAccountsModule { }
